import TimeSelector from './TimeSelector';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators, compose } from 'redux';

// Actions
import {
  setTeamIds,
  setStartTime,
  sendShiftServiceApptStart
} from 'store/reducers/appointment/actions';
import {
  setSelectedTimeslotInPromoRange,
  dateApptPickerTouchByUser
} from 'store/reducers/userInteractions/actions';

// Selectors
import { getStartTime } from 'store/reducers/appointment/selectors';
import { getDateApptPickerTouchByUser } from 'store/reducers/userInteractions/selectors';
import { getTimeslotsBySelectedDate } from 'store/reducers/availableTimes/selectors';
import {
  getActivePromotion,
  getPromoStartTime,
  getPromoEndTime,
  getPromoDaysOfWeekArray,
  getPromotionStartDate,
  getPromotionEndDate
} from 'store/reducers/promotions/selectors';

const mapStateToProps = state => {
  return {
    startTime: getStartTime(state),
    filteredTimeslots: getTimeslotsBySelectedDate(state),
    activePromo: getActivePromotion(state),
    promoStartTime: getPromoStartTime(state),
    promoEndTime: getPromoEndTime(state),
    promotionStartDate: getPromotionStartDate(state),
    promotionEndDate: getPromotionEndDate(state),
    isDateApptPickerTouchByUser: getDateApptPickerTouchByUser(state),
    daysOfWeek: getPromoDaysOfWeekArray(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setTeamIds,
      setStartTime,
      sendShiftServiceApptStart,
      setSelectedTimeslotInPromoRange,
      dateApptPickerTouchByUser
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TimeSelector);



// WEBPACK FOOTER //
// ./src/components/molecules/TimeSelector/TimeSelectorContainer.js